<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Tạo khách hàng`"/>
        <v-flex xs12 sm12 md8 lg6 xl6 offset-md2 offset-lg3 offset-xl3>
          <v-card>
            <v-card-text class="pa-10">
              <v-container>
                <h3>Thông tin hệ thống</h3>
                <v-form v-model="form1Valid" ref="form1">
                  <v-radio-group v-model="form.isDistributor">
                    <v-radio label="Là nhà phân phối" :value="true" :disabled="loggedUser.isDistributor && !loggedUser.isProvider"></v-radio>
                    <v-radio label="Là đại lý" :value="false"></v-radio>
                  </v-radio-group>
                  <v-autocomplete
                    label="Thuộc nhà phân phối"
                    item-text="name"
                    item-value="id"
                    v-show="!form.isDistributor"
                    v-model="form.parentAccountId"
                    :items="distributors"
                    :rules="[validate.required]"
                  ></v-autocomplete>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md8 lg6 xl6 offset-md2 offset-lg3 offset-xl3>
          <v-card>
            <v-container>
              <v-card-text class="pa-10">
                <h3>Thông tin khách hàng</h3>
                <v-form v-model="form2Valid" ref="form2">
                  <v-text-field v-model="form.name" :rules="[validate.required]" label="Tên"></v-text-field>
                  <v-text-field
                    label="Số điện thoại"
                    v-model="form.phone"
                    :rules="[validate.required, validate.min, validate.numeric]"
                    :error-messages="phoneUsedMessage"
                    @change="checkPhoneFromServer()"
                  ></v-text-field>
                  <v-text-field
                    label="Email"
                    v-model="form.email"
                    :rules="[validate.required, validate.email]"
                    :error-messages="emailUsedMessage"
                    @change="checkEmailFromServer()"
                  ></v-text-field>
                  <v-text-field
                    label="Mật khẩu"
                    v-model="form.password"
                    :append-icon="isShowPassword ? `visibility_off` : `visibility`"
                    :type="isShowPassword ? `text` : `password`"
                    :rules="[validate.required, validate.min]"
                    @click:append="isShowPassword = !isShowPassword"
                  ></v-text-field>
                  <v-text-field
                    label="CMND/MST"
                    v-model="form.taxCode"
                    :rules="[validate.numericOrEmpty]"
                  ></v-text-field>
                  <v-text-field v-model="form.address" label="Địa chỉ"></v-text-field>
                  <v-text-field v-model="form.remark" label="Ghi chú"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="cancel()">Hủy</v-btn>
                <v-btn falt color="primary" :loading="isLoading" @click="submit()">Tạo khách hàng</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import validate from '@/utils/validate';
import AppBar from '@/components/appbar';

export default {
  components: { AppBar },
  data () {
    return {
      form1Valid: false,
      form2Valid: false,
      validate: validate,
      phoneUsedMessage: '',
      emailUsedMessage: '',
      form: {
        name: '',
        phone: '',
        email: '',
        password: '',
        address: '',
        isDistributor: false,
        isDealer: false,
        parentAccountId: '',
        remark: '',
        taxCode: ''
      },
      distributors: [],
      isLoading: false,
      isShowPassword: false
    };
  },
  computed: {
    ...mapGetters(['loggedUser'])
  },
  watch: {
    'form.isDistributor' () {
      this.form.isDealer = !this.form.isDistributor;
    },
    deep: true
  },
  created () {
    if (this.loggedUser.isProvider) {
      this.getDistributors(this.loggedUser.accountId).then(res => {
        this.distributors = res;
      });
    } else {
      this.distributors.push({
        id: this.loggedUser.accountId,
        name: this.loggedUser.accountName
      });
    }
  },
  methods: {
    ...mapActions([
      'getDistributors',
      'checkEmail',
      'checkPhone',
      'createAccount'
    ]),
    checkPhoneFromServer () {
      if (this.form.phone && validate.numeric(this.form.phone)) {
        this.checkPhone(this.form.phone)
          .then(result => {
            this.phoneUsedMessage = result.data
              ? ''
              : result.code === validate.ERR_INVALID_PHONENUMBER
                ? 'Sai định dạng số điện thoại'
                : result.code === validate.ERR_PHONENUMBER_USED
                  ? 'Số điện thoại đã được sử dụng'
                  : '';
          })
          .catch(_ => {
            this.phoneUsedMessage = 'Không thể kiểm tra số điện thoại';
          });
      }
    },
    checkEmailFromServer () {
      if (this.form.email && validate.email(this.form.email)) {
        this.checkEmail(this.form.email)
          .then(result => {
            this.emailUsedMessage = '';
          })
          .catch(result => {
            this.emailUsedMessage =
              result.code === 'ERR_EMAIL_NOT_EXIST'
                ? 'Email không tồn tại trong hệ thống'
                : result.code === 'ERR_EMAIL_USED'
                  ? 'Email đã được sử dụng'
                  : '';
          });
      }
    },
    cancel () {
      window.history.back();
    },
    submit () {
      if (this.form1Valid && this.form2Valid) {
        this.isLoading = true;
        this.createAccount(this.form)
          .then(res => {
            this.isLoading = false;
            window.getApp.showMessage('Tạo khách hàng thành công');
            window.history.back();
          })
          .catch(_ => {
            this.isLoading = false;
            window.getApp.showMessage(
              'Tạo khách hàng thất bại, vui lòng thử lại',
              'error'
            );
          });
      } else {
        this.$refs.form1.validate();
        this.$refs.form2.validate();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/account/add.vue